/* Neropos inner pages (proposal): the home's water, on a page that scrolls as usual. Each part pins once it has been
   read down to its foot and the next rises over it like water, a crest on its top in its own colours, and the
   brand's drop that brings it falls head first into the crest as it comes (going back up, one leaps out of the
   water). The marks fall onto their places one after another, the bottles of the count land one by one as the
   number counts them and a drop flies from the buy button into the cart; the name at the foot that fills with water
   is water.js's, as are the waves, drops and lanes (the home's own, home-wow/v3.html). With reduced motion none of it moves:
   the page scrolls, the crests stand still and everything shows whole. */
(function () {
  var NP = window.NP, $ = NP.$, $$ = NP.$$, reduce = NP.reduce, root = document.documentElement;
  var FP = [0, 0];
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  // the brand's waves, drops and lanes: water.js's, loaded before this
  var W = NP.water, svgEl = W.svgEl, wave = W.wave, dropD = W.dropD, laneOf = W.laneOf, laneAt = W.laneAt;

  /* The crests: every part that rises has one on its top, its front fading into the part's own colour */
  // a colour as [r, g, b] from #rrggbb, rgb() or color(srgb …) (what color-mix computes to); and a mix of two of them
  function rgbOf(c) {
    c = String(c).trim();
    if (/^#[0-9a-f]{6}$/i.test(c)) { var n = parseInt(c.slice(1), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
    var m = c.match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    var v = m.slice(0, 3).map(Number);
    return /^color\(/.test(c) ? v.map(function (x) { return x * 255; }) : v;
  }
  function mixc(a, b, t) { return 'rgb(' + a.map(function (v, k) { return Math.round(v + (b[k] - v) * t); }).join(',') + ')'; }
  var LOOK = {
    white: { c: ['#BFE3FF', '#F2F9FF'], b: '#8FCBFF', d: ['#CFEBFF', '#FFFFFF'] },
    foam: { c: ['#BFE3FF', '#E8F0F9'], b: '#8FCBFF', d: ['#9FE6FF', '#1FB4FD'] },
    navy: { c: ['#3D7BFF', '#0C3A8C'], b: '#1F5BFF', d: ['#3D7BFF', '#04204E'] },
    sky: { c: ['#BFE3FF', '#DDEEFF'], b: '#8FCBFF', d: ['#FFFFFF', '#7FC2FF'] },
    deep: { c: ['#2F6BFF', '#0A2A66'], b: '#1647D6', d: ['#3D7BFF', '#021634'] },
    // a page in neutral colours (html.tone-neutral, the user 2026-10-20): its crests and drops in greys
    'n-white': { c: ['#E3E5E9', '#F6F7F8'], b: '#D3D6DB', d: ['#E3E5E9', '#8A8F98'] },
    'n-foam': { c: ['#DADDE2', '#EEF0F2'], b: '#C9CCD2', d: ['#E3E5E9', '#8A8F98'] },
    'n-deep': { c: ['#3A3D44', '#1D1F23'], b: '#2A2D33', d: ['#9DA1A9', '#141518'] },
    'n-navy': { c: ['#5A5E66', '#2B2E34'], b: '#3A3D44', d: ['#C9CCD2', '#2B2E34'] },
    'n-sky': { c: ['#DADDE2', '#EEF0F2'], b: '#C9CCD2', d: ['#FFFFFF', '#9DA1A9'] },
    // White Linen's page (html.p-linen, the user 2026-10-20): the beige and gold of its box, a deep brown
    'l-white': { c: ['#EADBC4', '#FAF6EF'], b: '#DFCCAE', d: ['#EFE2CD', '#FFFFFF'] },
    'l-foam': { c: ['#E6D5BB', '#F1EEEA'], b: '#D9C4A3', d: ['#EADBC4', '#B8925A'] },
    'l-navy': { c: ['#A88B62', '#4A3B2E'], b: '#8A6A43', d: ['#D9BF93', '#3B3027'] },
    'l-sky': { c: ['#E9D9BF', '#F3EBDF'], b: '#DCC6A4', d: ['#FFFFFF', '#C9A878'] },
    'l-deep': { c: ['#8A6A43', '#3A2E24'], b: '#75583A', d: ['#C9A878', '#2A221B'] },
    // Sensitive's page (html.p-sensitive): the mint and green of its box, a deep green
    's-white': { c: ['#BFE4D6', '#F2FAF6'], b: '#A6D8C5', d: ['#D2EEE3', '#FFFFFF'] },
    's-foam': { c: ['#BFE4D6', '#E9F2EE'], b: '#A6D8C5', d: ['#BDE6D6', '#3E9B7E'] },
    's-navy': { c: ['#4FAE8E', '#165A47'], b: '#2E8A6C', d: ['#8FD6BC', '#0F4436'] },
    's-sky': { c: ['#BFE4D6', '#D8EFE6'], b: '#A6D8C5', d: ['#FFFFFF', '#79C2A8'] },
    's-deep': { c: ['#3E9B7E', '#0F4436'], b: '#23775E', d: ['#7FCDB2', '#0B3229'] }
  };
  // the drop that flies into the cart, in the page's colours
  var CARTDROP = { '': ['#9FE6FF', '#1F5BFF'], 'l-': ['#EADBC4', '#8A6A43'], 's-': ['#C6E8DB', '#23775E'] };
  var tone = root.classList.contains('tone-neutral') ? 'n-' : root.classList.contains('p-linen') ? 'l-' : root.classList.contains('p-sensitive') ? 's-' : '';
  var rises = $$('[data-rise]'), cn = 0;
  rises.forEach(function (sec, i) {
    var name = sec.getAttribute('data-rise'), L = LOOK[tone + name] || LOOK[name] || LOOK.white, id = 'crg' + (++cn), bg = getComputedStyle(sec).backgroundColor;
    // a drop of the part's own colour (data-drop: its tail's and its head's), e.g. a stain's
    var own = (sec.getAttribute('data-drop') || '').split(' ').filter(function (c) { return c; });
    // and its crest in its own wash too (a stain's page, the user 2026-11-01): the part's colour with a little of the stain
    var B = rgbOf(bg), H = rgbOf(own[1] || '');
    if (own.length === 2 && B && H) L = { c: [mixc(B, H, name === 'white' ? .14 : .22), mixc(B, [255, 255, 255], .3)], b: mixc(B, H, name === 'white' ? .2 : .32), d: own };
    else if (own.length === 2) L = { c: L.c, b: L.b, d: own };
    var box = document.createElement('div'); box.className = 'crest'; box.setAttribute('aria-hidden', 'true');
    var sv = svgEl('svg', { viewBox: '0 0 1440 60', preserveAspectRatio: 'none', focusable: 'false' }, box);
    var gr = svgEl('linearGradient', { id: id, x1: 0, y1: 8, x2: 0, y2: 58, gradientUnits: 'userSpaceOnUse' }, svgEl('defs', {}, sv));
    svgEl('stop', { offset: 0, 'stop-color': L.c[0] }, gr); svgEl('stop', { offset: .5, 'stop-color': L.c[1] }, gr); svgEl('stop', { offset: 1, 'stop-color': bg }, gr);
    svgEl('path', { 'class': 'crest__w crest__w--back', d: wave(-240, 2400, 480, 18, 10, 60), fill: L.b }, sv);
    svgEl('path', { 'class': 'crest__w', d: wave(0, 2400, 480, 26, 12, 60), fill: 'url(#' + id + ')' }, sv);
    sec._bump = svgEl('g', { transform: 'translate(-200 30) scale(1 0)' }, sv);
    svgEl('path', { d: 'M-60 14C-30 14-20-24 0-24S30 14 60 14Z', fill: 'url(#' + id + ')' }, sec._bump);
    sec.insertBefore(box, sec.firstChild);
    // where its drop sets off and lands across the screen, and which way its lane bends: from side to side
    sec._look = L; sec._x = i % 2 ? [.3, .36] : [.68, .62]; sec._k = i % 2 ? -1 : 1;
  });

  /* The stack: a part pins once its foot is at the screen's foot (a short one under the header), and the next rises
     over it; one that the next has covered whole is not drawn, and its loops wait. A part with things to open or press
     (data-nopin: the buy, the questions, the other scents) never pins, so nothing rises over them: it scrolls away */
  var parts = $$('[data-part]'), hdr = $('.hdr'), stack = !reduce && parts.length > 1 && window.CSS && CSS.supports('position', 'sticky');
  if (stack) root.classList.add('stack-on');
  function pinAll() {
    if (!stack) return;
    var hd = hdr ? hdr.offsetHeight : 0, vh = innerHeight;
    parts.forEach(function (sec, i) {
      sec.style.top = sec.hasAttribute('data-nopin') ? '' : Math.min(hd, vh - sec.offsetHeight) + 'px';
      sec.style.zIndex = String(i + 1);
    });
  }
  function nextPart(sec) { var i = parts.indexOf(sec); return i > -1 ? parts[i + 1] || null : null; }
  NP.covered = function (sec) { return !!(sec && sec._covered); };
  function paintCovered() {
    if (!stack) return;
    var hd = hdr ? hdr.offsetHeight : 0, vh = innerHeight;
    parts.forEach(function (sec) {
      // one that never pins is only gone once it has left the top of the screen (the header can be see-through over it)
      var nx = nextPart(sec), cov = false;
      if (nx && nx.offsetHeight) cov = nx.getBoundingClientRect().top <= (sec.hasAttribute('data-nopin') ? 0 : hd + 1);
      if (cov === !!sec._covered) return;
      sec._covered = cov; sec.style.visibility = cov ? 'hidden' : '';
      $$('video', sec).forEach(function (v) {
        if (cov) { if (!v.paused) v.pause(); return; }
        var r = v.getBoundingClientRect();
        if (v.getAttribute('src') && r.bottom > 0 && r.top < vh) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
  }

  /* The drops: the brand's drop flying head first along a lane of its own, in its exact shape all the way, seen only
     above the water's surface when it has one; under the header, except the one that flies into the cart */
  var FX = { low: null, top: null, list: [], bumps: [], raf: 0, W: 0, H: 0, id: 0 };
  if (!reduce) { FX.low = svgEl('svg', { 'class': 'fx', 'aria-hidden': 'true' }, document.body); FX.top = svgEl('svg', { 'class': 'fx fx--top', 'aria-hidden': 'true' }, document.body); }
  function fxSize() { if (!FX.low) return; FX.W = innerWidth; FX.H = innerHeight; [FX.low, FX.top].forEach(function (s) { s.setAttribute('viewBox', '0 0 ' + FX.W + ' ' + FX.H); }); }
  fxSize();
  // o: lane and h(t) (its head's place along the lane, t s after it set off), or ball (a small drop thrown up: x y vx
  // vy g); R, L (from the tail's tip to the head's centre); c [tail colour, head colour]; surf() the water's surface on
  // the screen; down: it goes into the water (gone once its tail is under it; hit(x, y) as its head gets there; end()
  // once it is gone), else it comes up out of the water and flies off over the top
  function fxDrop(o) {
    if (!FX.low) { if (o.end) o.end(); return; }
    var k = ++FX.id, svg = o.top ? FX.top : FX.low, defs = svg._defs || (svg._defs = svgEl('defs', {}, svg));
    o.cp = svgEl('clipPath', { id: 'fxc' + k, clipPathUnits: 'userSpaceOnUse' }, defs);
    o.cr = svgEl('rect', { x: -2000, y: -2000, width: 9999, height: 9999 }, o.cp);
    o.gr = svgEl('linearGradient', { id: 'fxg' + k, gradientUnits: 'userSpaceOnUse' }, defs);
    svgEl('stop', { offset: 0, 'stop-color': o.c[0] }, o.gr); svgEl('stop', { offset: 1, 'stop-color': o.c[1] }, o.gr);
    o.g = svgEl('g', { 'clip-path': 'url(#fxc' + k + ')' }, svg);
    o.p = svgEl('path', { fill: 'url(#fxg' + k + ')' }, o.g);
    if (!o.ball) o.gl = svgEl('ellipse', { fill: '#fff', opacity: .5 }, o.g);
    o.n = o.ball ? 8 : 18; o.X = new Float64Array(o.n); o.Y = new Float64Array(o.n); o.t0 = performance.now(); o.hitDone = false;
    FX.list.push(o); fxRun();
  }
  function fxGone(o) { o.g.remove(); o.cp.remove(); o.gr.remove(); if (o.end) o.end(); }
  function fxRun() { if (!FX.raf && (FX.list.length || FX.bumps.length)) FX.raf = requestAnimationFrame(fxStep); }
  function fxStep(now) {
    FX.raf = 0;
    for (var i = FX.list.length - 1; i >= 0; i--) {
      var o = FX.list[i], t = (now - o.t0) / 1000, s = o.surf ? o.surf() : null, gone = t > 3.5, j, n = o.n;
      if (o.ball) {
        var b = o.ball, vy = b.vy + b.g * t, sp = Math.hypot(b.vx, vy) || 1, px = b.x + b.vx * t, py = b.y + b.vy * t + .5 * b.g * t * t;
        for (j = 0; j < n; j++) { var f = o.L * (1 - j / (n - 1)); o.X[j] = px - b.vx / sp * f; o.Y[j] = py - vy / sp * f; }
        if (vy > 0 && s !== null && o.Y[0] > s + 1) gone = true;
      } else {
        var h = o.h(t);
        for (j = 0; j < n; j++) { laneAt(o.lane, h - o.L * (1 - j / (n - 1)), FP, 0); o.X[j] = FP[0]; o.Y[j] = FP[1]; }
        // a drop with an end of its own (into the cart) is gone once its head gets there
        if (o.until && h >= o.until) gone = true;
      }
      var e = n - 1, hx = o.X[e], hy = o.Y[e], dx = hx - o.X[e - 2], dy = hy - o.Y[e - 2], dl = Math.hypot(dx, dy) || 1;
      o.p.setAttribute('d', dropD(o.X, o.Y, n, o.R));
      o.gr.setAttribute('x1', o.X[0].toFixed(1)); o.gr.setAttribute('y1', o.Y[0].toFixed(1));
      o.gr.setAttribute('x2', (hx + dx / dl * o.R).toFixed(1)); o.gr.setAttribute('y2', (hy + dy / dl * o.R).toFixed(1));
      if (o.gl) {
        // a glint on its head, up and to the left, where the light falls
        var gx = hx - .38 * o.R, gy = hy - .44 * o.R;
        o.gl.setAttribute('cx', gx.toFixed(1)); o.gl.setAttribute('cy', gy.toFixed(1)); o.gl.setAttribute('rx', (o.R * .3).toFixed(1)); o.gl.setAttribute('ry', (o.R * .19).toFixed(1));
        o.gl.setAttribute('transform', 'rotate(-50 ' + gx.toFixed(1) + ' ' + gy.toFixed(1) + ')');
      }
      if (s !== null) o.cr.setAttribute('height', Math.max(0, s + 2000).toFixed(1));
      if (o.until) { /* its own end, above */ }
      else if (o.down && !o.ball) {
        if (s !== null && !o.hitDone && hy + o.R >= s) { o.hitDone = true; if (o.hit) o.hit(hx, s); }
        if ((s !== null && o.Y[0] > s + 2) || o.Y[0] > FX.H + 40) gone = true;
      } else if (!o.down && hy < -o.R - 4 && o.Y[0] < -4) gone = true;
      if (gone) { FX.list.splice(i, 1); fxGone(o); }
    }
    // a crest's bulge: up and back, a smaller one after it, then at rest (it is water added on top, never below)
    for (i = FX.bumps.length - 1; i >= 0; i--) {
      var bp = FX.bumps[i], tb = (now - bp.t0) / 1000, kk = tb < .26 ? Math.sin(Math.PI * tb / .26) : tb >= .4 && tb < .64 ? .3 * Math.sin(Math.PI * (tb - .4) / .24) : 0;
      bp.g.setAttribute('transform', 'translate(' + bp.xv.toFixed(1) + ' 30) scale(' + bp.sx.toFixed(3) + ' ' + kk.toFixed(3) + ')');
      if (tb >= .64) FX.bumps.splice(i, 1);
    }
    fxRun();
  }
  function bump(sec, x) {
    if (!sec._bump) return;
    var W = Math.max(1, FX.W), px = clamp(W * .16, 64, 120);
    FX.bumps = FX.bumps.filter(function (b) { return b.g !== sec._bump; });
    FX.bumps.push({ g: sec._bump, t0: performance.now(), xv: x / W * 1440, sx: px * 1440 / W / 120 }); fxRun();
  }
  // the drop that brings a part: from over the top of the screen down onto its crest as it comes, head first, bending
  // on a lane of its own; it goes into the water and splashes. Going back, one leaps head first out of the water and
  // flies off over the top
  NP.fxLog = [];
  function partDrop(sec, down) {
    var L = sec._look, W = FX.W, H = FX.H, r = clamp(W / 72, 10, 20), len = r * 4.2, x0 = sec._x[0] * W, x1 = sec._x[1] * W, k = sec._k;
    if (NP.fxLog.length < 40) NP.fxLog.push({ part: sec.id || sec.className, down: down, at: Math.round(performance.now()), y: Math.round(scrollY), top: Math.round(sec.getBoundingClientRect().top) });
    var surf = function () { return sec.getBoundingClientRect().top - 30; };
    if (down) {
      fxDrop({ lane: laneOf([x0, -len - r - 8], [x0 + k * .07 * W, .3 * H], [x1 - k * .05 * W, .62 * H], [x1, H + 260]), R: r, L: len, c: L.d, surf: surf, down: true,
        h: function (t) { return 760 * t + 1150 * t * t; },
        hit: function (x, y) {
          bump(sec, x);
          [-1, 1].forEach(function (sg, j) {
            fxDrop({ ball: { x: x + sg * 5, y: y + 3, vx: sg * (120 + 70 * j), vy: -(390 + 60 * (1 - j)), g: 1700 }, R: r * .3, L: r * 1.1, c: L.d, surf: surf, down: true });
          });
        } });
    } else {
      var y0 = surf(), xa = x1 + k * .02 * W, xb = x0 - k * .05 * W;
      fxDrop({ lane: laneOf([xa, y0 + len + 2 * r], [xa - k * .03 * W, y0 - .3 * H], [xb, .2 * H], [xb + k * .04 * W, -400]), R: r, L: len, c: L.d, surf: surf, down: false,
        h: function (t) { return 2300 * t - 900 * t * t; } });
    }
  }

  /* Into the cart: a drop springs from the buy button and flies head first up into the bag, bending on its way, and
     the count goes up as it gets there */
  NP.flyToCart = function (from, done) {
    var cart = $('[data-carticon]');
    if (reduce || !FX.top || !cart || !from) { done(); return; }
    var a = from.getBoundingClientRect(), c = cart.getBoundingClientRect(), x0 = a.left + a.width * .5, y0 = a.top + 4, x3 = c.left + c.width / 2, y3 = c.top + c.height / 2;
    var r = 8, len = r * 4.2, side = x0 < x3 ? -1 : 1;
    var lane = laneOf([x0, y0], [x0 + (x3 - x0) * .1, y0 - (y0 - y3) * .6], [x3 + side * 80, y3 + 120], [x3, y3]);
    fxDrop({ lane: lane, R: r, L: len, c: CARTDROP[tone] || CARTDROP[''], top: true, until: lane.len,
      h: function (t) { return 260 * t + 2200 * t * t; },
      end: function () {
        done();
        if (cart.animate) cart.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)', offset: .4 }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
      } });
  };

  /* Marks that fall onto their places one after another (data-dropin; data-fall: how far, else from over the top of
     the screen; data-delay before the first), their sign and words coming in as each lands */
  var lists = $$('[data-dropin]');
  if (!reduce) lists.forEach(function (ul) { ul.classList.add('dropwait'); });
  function dropIn(ul) {
    var base = Number(ul.getAttribute('data-delay') || 0), far = Number(ul.getAttribute('data-fall') || 0);
    $$(':scope > li', ul).forEach(function (li, i) {
      li._tm = setTimeout(function () {
        li.classList.add('dropgo');
        // the drop falls (its sign and words come in by the stylesheet as it lands, so they can never stay hidden)
        var sv = li.querySelector('svg'), r = sv.getBoundingClientRect(), fall = far || Math.round(r.bottom + 40);
        li._an = [sv.animate([{ transform: 'translateY(' + (-fall) + 'px)', easing: 'cubic-bezier(.55,0,.85,.5)' }, { transform: 'translateY(5px)', offset: .74, easing: 'cubic-bezier(.3,.6,.4,1)' }, { transform: 'translateY(-3px)', offset: .87, easing: 'ease-in-out' }, { transform: 'none' }], { duration: far ? 640 : 820 })];
      }, base + (far ? 140 : 170) * i);
    });
  }
  function dropOut(ul) {
    $$(':scope > li', ul).forEach(function (li) { clearTimeout(li._tm); (li._an || []).forEach(function (a) { a.cancel(); }); li._an = null; li.classList.remove('dropgo'); });
  }
  // seen: on the screen, and not under the part that has risen over its own (a list in the first screen, data-fall,
  // as soon as it shows whole; one further down once it is well up the screen)
  function seenWhole(el, deep) {
    var r = el.getBoundingClientRect(), vh = innerHeight, part = el.closest('[data-part]'), nx = part && stack ? nextPart(part) : null;
    if (!r.height || r.bottom <= 0 || (part && part._covered)) return false;
    if (nx && nx.offsetHeight && nx.getBoundingClientRect().top < r.bottom + 4) return false;
    return deep ? r.bottom < vh - 4 : r.top < vh * .88;
  }
  function paintLists() {
    if (reduce) return;
    var vh = innerHeight;
    lists.forEach(function (ul) {
      var part = ul.closest('[data-part]'), pr = part ? part.getBoundingClientRect() : ul.getBoundingClientRect();
      if (!ul._on && seenWhole(ul, ul.hasAttribute('data-fall'))) { ul._on = true; dropIn(ul); }
      else if (ul._on && pr.top >= vh) { ul._on = false; dropOut(ul); }
    });
  }

  /* Scenes that play once they are seen (data-play: the dose's drums fill and their sheets fall in), again after the
     reader has gone back above them */
  var plays = $$('[data-play]');
  if (!reduce) plays.forEach(function (el) { el.classList.add('pwait'); });
  function paintPlays() {
    if (reduce) return;
    var vh = innerHeight;
    plays.forEach(function (el) {
      var part = el.closest('[data-part]'), pr = part ? part.getBoundingClientRect() : el.getBoundingClientRect();
      if (!el._on && seenWhole(el, false)) { el._on = true; el.classList.remove('pwait'); el.classList.add('play'); }
      else if (el._on && pr.top >= vh) { el._on = false; el.classList.remove('play'); el.classList.add('pwait'); }
    });
  }

  /* The count: the bottles land one by one and the number counts them */
  var counts = $$('[data-countin]');
  counts.forEach(function (box) { if (!reduce) box.classList.add('dropwait'); });
  function countIn(box) {
    var num = $('[data-count]', box.closest('[data-part]') || document), items = $$(':scope > *', box), n = 0;
    if (num) num.textContent = '0';
    items.forEach(function (el, i) {
      el._tm = setTimeout(function () {
        el.classList.add('dropgo');
        el._an = el.animate([{ transform: 'translateY(-70px)', easing: 'cubic-bezier(.55,0,.85,.5)' }, { transform: 'translateY(3px)', offset: .78, easing: 'ease-out' }, { transform: 'none' }], { duration: 520 });
        el._an.onfinish = function () { n++; if (num) num.textContent = String(n); };
      }, 160 + 110 * i);
    });
  }
  function countOut(box) {
    $$(':scope > *', box).forEach(function (el) { clearTimeout(el._tm); if (el._an) { el._an.onfinish = null; el._an.cancel(); } el.classList.remove('dropgo'); });
    var num = $('[data-count]', box.closest('[data-part]') || document); if (num) num.textContent = num.getAttribute('data-count');
  }
  function paintCounts() {
    if (reduce) return;
    var vh = innerHeight;
    counts.forEach(function (box) {
      var r = box.getBoundingClientRect(), part = box.closest('[data-part]'), pr = part ? part.getBoundingClientRect() : r;
      if (!box._on && seenWhole(box, false)) { box._on = true; countIn(box); }
      else if (box._on && pr.top >= vh) { box._on = false; countOut(box); }
    });
  }
  /* The scroll: the drops that bring the parts (none for a part the page jumped right past), then the rest */
  var lastY = scrollY, ticking = false;
  function paint() {
    ticking = false;
    var y = scrollY, dir = y > lastY ? 1 : y < lastY ? -1 : 0, jump = Math.abs(y - lastY) > innerHeight * .9, vh = innerHeight, now = performance.now();
    lastY = y;
    rises.forEach(function (sec) {
      if (!sec.offsetHeight) { sec._top = undefined; return; }
      var top = sec.getBoundingClientRect().top, was = sec._top; sec._top = top;
      if (was === undefined || jump || !FX.low) return;
      if (dir > 0 && was >= vh - 8 && top < vh - 8) partDrop(sec, true);
      else if (dir < 0 && was < vh * .8 && top >= vh * .8 && now - (sec._leap || 0) > 1500) { sec._leap = now; partDrop(sec, false); }
    });
    paintCovered(); if (NP.paintHeader) NP.paintHeader(); paintLists(); paintPlays(); paintCounts();
    if (NP.paintBar) NP.paintBar();
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
  addEventListener('scroll', onScroll, { passive: true });
  var rzT = 0;
  function resized() { fxSize(); pinAll(); onScroll(); }
  addEventListener('resize', function () { clearTimeout(rzT); rzT = setTimeout(resized, 80); });
  if (window.ResizeObserver && stack) { var ro = new ResizeObserver(function () { clearTimeout(rzT); rzT = setTimeout(resized, 40); }); parts.forEach(function (p) { ro.observe(p); }); }
  pinAll();
  paint();
  NP.repaint = resized;
})();
